module.exports = "/_next/static/images/game-2-intro-tutorial-underline1-281fd2979e998398c32b85afe5896977.png";